import { render, staticRenderFns } from "./UiTruncateText.vue?vue&type=template&id=3679c03e&scoped=true&"
import script from "./UiTruncateText.vue?vue&type=script&lang=ts&"
export * from "./UiTruncateText.vue?vue&type=script&lang=ts&"
import style0 from "./UiTruncateText.vue?vue&type=style&index=0&id=3679c03e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679c03e",
  null
  
)

export default component.exports